export const clientStories: {
  title: string;
  description: string;
  src: string;
  thumbnail: string;
}[] = [
  {
    title: "iCXeed x Scene to Believe - Intelligent Seasonal Peak Planning",
    description:
      "Stefan Hutton, CEO of Scene to Believe, partnered with iCXeed to build a cognitive operation on Amazon Connect and Amazon Bedrock that scales to meet seasonal peak demand every Christmas.",
    src: "https://www.youtube.com/embed/z3COnkmA8hQ",
    thumbnail: "https://img.youtube.com/vi/z3COnkmA8hQ/maxresdefault.jpg",
  },
];
